module.exports = __webpack_public_path__ + "img/htc10.9db295d8.jpg";